import { Dropdown, ButtonGroup } from "react-bootstrap";
import { useFilters } from "../context/GlobalFilterContext";
import { useEffect } from "react";

const storedAccounts = JSON.parse(localStorage.getItem("accountOptions") || "[]");
const storedMarketplaces = JSON.parse(localStorage.getItem("marketplaceOptions") || "[]");

const accountOptions = storedAccounts.length
  ? storedAccounts
  : [{ label: "Account 41", value: "41" }];

const marketplaceOptions = storedMarketplaces.length
  ? storedMarketplaces
  : [{ label: "Amazon US", value: "ATVPDKIKX0DER" }];

function GlobalFilters() {
  const { account, setAccount, marketplace, setMarketplace } = useFilters();

  useEffect(() => {
    if (!account && accountOptions.length) {
      setAccount(accountOptions[0].value);
    }
    if (!marketplace && marketplaceOptions.length) {
      setMarketplace(marketplaceOptions[0].value);
    }
  }, []);
 //console.log(accountOptions);
 
  return (
    <div className="global-filters">
      <Dropdown as={ButtonGroup} className="me-2">
        <Dropdown.Toggle variant="secondary">
          {accountOptions.find((a) => a.value == account)?.label || "Select Account"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-dark">
          {accountOptions.map((opt) => (
            <Dropdown.Item
              key={opt.value}
              active={opt.value == account}
              onClick={() => setAccount(opt.value)}
            >
              {opt.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown as={ButtonGroup}>
        <Dropdown.Toggle variant="secondary">
          {marketplaceOptions.find((m) => m.value === marketplace)?.label || "Select Marketplace"}
        </Dropdown.Toggle>
        <Dropdown.Menu  className="dropdown-menu-dark">
          {marketplaceOptions.map((opt) => (
            <Dropdown.Item
              key={opt.value}
              active={opt.value === marketplace}
              onClick={() => setMarketplace(opt.value)}
            >
              {opt.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default GlobalFilters;
